import EarnStar from '../assets/earnStar.png';
import Footer from '../components/Footer';
import styled from 'styled-components';

const Container = {
    width: '100%',
    height: 'auto',
    background: ' #edf0f5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    fontFamily: 'Space Grotesk, Sans Serif',
    overflow: 'hidden',
};

const RadialGradient = styled.div`
    position: absolute;
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientA = styled.div`
    position: absolute;
    top: 400px;
    left: 0;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientB = styled.div`
    position: absolute;
    top: 900px;
    left: -175px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const RadialGradientC = styled.div`
    position: absolute;
    right: -100px;
    bottom: -175px;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle at center, rgba(120, 3, 255, 0.2), #060514, #060514);
    background-size: cover;
    z-index: 1;
    `;

const InfoWrapper = {
    width: '70%',
    maxWidth: '100%',
    height: 'auto',
    border: '1px solid rgba(0, 122, 204, 0.5)',
    backgroundColor: 'rgba(255, 255, 255, 1)',    
    borderRadius: '20px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    margin: '40px auto',
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
};

const InfoWrapperHover = {
    ...InfoWrapper,
    transform: 'scale(1.02)',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.35)',
};

const InfoWrapperTopRow = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: '20px',
    gap: '10px',
};

const InfoText = {
    fontSize: '12px',
    color: 'rgba(0, 0, 0, 0.75)',
    fontWeight: '400',
    lineHeight: '1.6',
};

const InfoTitle = {
    fontSize: '20px',
    color: 'rgba(0, 0, 0, 0.9)',
    fontWeight: '700',
};

const IconStyle = {
    width: '30px',
    height: '30px',
};


const TitleWrapper = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '15px',
    marginBottom: '15px',
    zIndex: '2',
};

const MainWrapper = {
    paddingBottom: '125px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    position: 'relative',
    zIndex: '2',
};

const Title = {
    fontSize: '22px',
    color: 'rgba(0, 0, 0, 0.9)',
    fontWeight: '600',
    marginLeft: '15px',
};

const Button = {
    width: '100%',
    background: '#060514', 
    borderRadius: '10px',
    border: '2px solid #060514',
    fontWeight: '500',
    fontSize: '12px',
    cursor: 'pointer',
    transition: 'transform 0.3s ease, background-color 0.3s ease',
    textAlign: 'center',
    boxShadow: '0 5px 10px rgba(0, 0, 0, 0.5)',
    marginTop: '20px',
    padding: '7.5px 0px',
    textDecoration: 'none',
    ':hover': {
        backgroundColor: '#444444',
        transform: 'scale(1.05)',
    },
};

const ButtonText = {
        fontSize: '12px',
        color: 'white',
        fontWeight: '600',
        lineHeight: '1.6',
    };

const ConceptAbout = () => {

    const handle = async () => {
        window.open('https://apps.apple.com/us/app/hydrix/id6739980773', '_blank');
    
    }
    return (
        <div style={Container}>
            
            <div style={TitleWrapper}>
                <div style={Title}>Common Questions</div>
            </div>
            <div style={MainWrapper}>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Gems</div>
                    </div>
                    <div style={InfoText}>Hydrix Gems are a valuable in-app currency that
                        can be earned through daily mining or by completing engaging tasks 
                        on the Telegram mini app. These gems provide users with a flexible 
                        and rewarding experience, as they can be exchanged at any time for 
                        Hx tokens or a variety of other exciting items. Start mining and 
                        exploring today to maximize your rewards with Hydrix Gems!
                    </div>
                    <button style={Button}>
                        <div style={ButtonText}>Exchange Coming Soon</div>
                    </button>
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Difference between Hx and Gems</div>
                    </div>
                    <div style={InfoText}>The Hx token and Hydrix Gems serve different
                        purposes within the Hydrix ecosystem. Gems are not a blockchain 
                        token but act as the in-app currency for the Hydrix Telegram 
                        mini app. They can be earned through daily mining and tasks and 
                        traded anytime before the Token Generation Event (TGE) for Hx tokens. 
                        Additionally, Gems can be used for other exciting rewards, making 
                        them a versatile currency for users. In contrast, Hx tokens are 
                        blockchain-based assets with broader utility and value beyond the 
                        Telegram app.
                    </div>
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>Do I use the same account as the app?</div>
                    </div>
                    <div style={InfoText}>Your Hydrix account on the Telegram mini app is 
                        separate from your account in the main Hydrix app. This is because 
                        we utilize Telegram's account security and setup for the mini app. 
                        However, you will have the ability to link your Telegram account 
                        with your Hydrix app account seamlessly through the Hydrix Gem 
                        Exchange, ensuring a unified experience across both platforms.
                    </div>
                        <button style={Button}>
                            <div style={ButtonText}>Get The App</div>
                        </button>
                </div>
                <div style={InfoWrapper}>
                    <div style={InfoWrapperTopRow}>
                        <img src={EarnStar} />
                        <div style={InfoTitle}>What are the value of Gems?</div>
                    </div>
                    <div style={InfoText}>Mining Gems through the Telegram mini app and 
                        mining Hydrix through the main app are designed to offer similar 
                        long-term value, though they may not be exactly equivalent. Both 
                        methods contribute meaningfully to your overall rewards within 
                        the Hydrix ecosystem, ensuring fairness and encouraging participation 
                        on either platform.
                    </div>
                </div>
            </div>
            <Footer />
        </div>

    )
};

export default ConceptAbout;